<div class="charity-sub-header" id="charity-sub-header" *ngIf="currentURL == 'edit-charity' || currentURL == 'your-profile' || currentURL=='charity-settings' || currentURL=='charity-couple' ">
    <div class="charity-menu">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div [ngClass]="{'d-flex': currentURL=='edit-charity'}" class="justify-content-between">
                        <ul *ngIf= "currentURL=='edit-charity'">
                            <li>
                                <a href="javascript:void(0);" [routerLink]="['/your-profile/charity']"><span class="menuName">Return to dashboard</span></a>
                            </li>
                        </ul>
                        <ul>
                            <li [routerLinkActive]="['active']" [ngClass]="{'active': currentURL=='edit-charity'}" [routerLinkActiveOptions]="{exact:true}">
                                <a href="javascritp:void(0)"  [routerLink]="['/your-profile/charity']"><span class="menuIcon menuIcon3"> </span> <span class="menuName">my charity</span></a>
                            </li>
                            <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                                <a href="javascritp:void(0)" [routerLink]="['/charity-couple']"><span class="menuIcon menuIcon2"> </span> <span class="menuName">couples</span></a>
                            </li>
                            <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                                <a href="javascritp:void(0)"  [routerLink]="['/charity-settings']"><span class="menuIcon"> </span> <span class="menuName">settings</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>